<template>
    <select v-model="diseaseOrAccident">
        <option :value="null">All</option>
        <option value="disease" v-if="claimType !== 'personal_injury'">Disease</option>
        <option value="accident">Accident</option>
    </select>
</template>

<script>
    export default {
        name: 'disease-or-accident',
        computed: {
            claimType: {
                get() {
                    return this.$store.getters['dashboards/claimType'];
                },
            },
            diseaseOrAccident: {
                get() {
                    return this.$store.getters['dashboards/diseaseOrAccident'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'diseaseOrAccident', value});
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'accidentType', value: null});
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'diseaseType', value: null});
                },
            },
        }
    }
</script>



// WEBPACK FOOTER //
// DiseaseOrAccident.vue?0d846ad0